/**
 * ValenceBar - Horizontal stacked bar showing positive/neutral/negative distribution.
 */

import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { VALENCE_COLORS } from '../../../BehavioralWorkbench/constants/workbenchConfig';

function ValenceBar({ positive = 0, neutral = 0, negative = 0, height = 20 }) {
  const total = positive + neutral + negative;
  if (total === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No data
      </Typography>
    );
  }

  const pct = (val) => ((val / total) * 100).toFixed(1);

  const segments = [
    { label: 'Positive', value: positive, color: VALENCE_COLORS.positive, pct: pct(positive) },
    { label: 'Neutral', value: neutral, color: VALENCE_COLORS.neutral, pct: pct(neutral) },
    { label: 'Negative', value: negative, color: VALENCE_COLORS.negative, pct: pct(negative) },
  ].filter((s) => s.value > 0);

  return (
    <Box>
      {/* Stacked Bar */}
      <Box
        sx={{
          display: 'flex',
          height,
          borderRadius: 1,
          overflow: 'hidden',
          mb: 1,
        }}
      >
        {segments.map((seg) => (
          <Tooltip key={seg.label} title={`${seg.label}: ${seg.value} (${seg.pct}%)`}>
            <Box
              sx={{
                width: `${seg.pct}%`,
                bgcolor: seg.color,
                transition: 'width 0.5s ease',
                minWidth: seg.value > 0 ? 4 : 0,
              }}
            />
          </Tooltip>
        ))}
      </Box>

      {/* Legend */}
      <Box sx={{ display: 'flex', gap: 2 }}>
        {segments.map((seg) => (
          <Box key={seg.label} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: seg.color,
              }}
            />
            <Typography variant="caption" color="text.secondary">
              {seg.label}: {seg.value} ({seg.pct}%)
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default ValenceBar;
